<style scoped lang="scss">
	.gantt_split_parent,
	.gantt_split_subproject {
		opacity: 0;
	}

	::v-deep .gantt_task_line.gantt_task_inline_color .gantt_task_progress {
		background-color: transparent;
		opacity: 1;
	}

	::v-deep .gantt_task_line.gantt_task_inline_color {
		border-color: transparent
	}

	::v-deep .scale_class {
		background-color: #F5F7FA !important;
		color: #454545 !important
	}

	::v-deep .scale_weekend {
		color: #454545 !important;
		background-color:#ECF5FF !important
	}

	::v-deep .grid_class {
		background-color: #F5F7FA !important
	}

	::v-deep .column_weekend {
		background-color: #ECF5FF !important
	}




	::v-deep .gantt_task_line {
		border: none !important;
		border-radius: 0px;
	}
</style>
<style lang="scss">

</style>
<template>
	<div id="device_load_gantt" style="width: 100%;height: 100%;padding: 20px;display:flex;flex-direction: column;"
		:style="{'width':'100%','height':'100%'}">

		<div>
			<el-form size="mini" :inline="true" class="demo-form-inline">
				<el-form-item :label="$t('shijianfanwei')">
					<yi_time_input type="datetimerange" :start.sync="startTime" :end.sync="endTime" :clearable="false">
					</yi_time_input>
				</el-form-item>
				<el-form-item>
					<el-button :loading="setTimeRangeLoading" @click="setTimeRange()" type="primary" plain="plain">
						{{$t('sousuo')}}
					</el-button>
				
				</el-form-item>
			</el-form>
		</div>
		<div style="width:100%;flex:1;"  class="ganttContainer" ref="planGanttContainer"></div>
		<el-drawer :visible.sync="isShowDetailDialog" :show-close="false" :direction="'rtl'" :size="374"
			:destroy-on-close="true" :withHeader="false" :append-to-body="true" >
			<div style="margin: 40px 28px;">
				<el-descriptions :column="1">
					<el-descriptions-item :label="$t('tingchanjihuamingcheng')">{{currentPlan.name}}
					</el-descriptions-item>
					<el-descriptions-item :label="$t('tingchanleixing')">
						{{$t(store.state.dictJsonAll['SHUTDOWN_TYPE'][currentPlan.shutdownType+''])}}
					</el-descriptions-item>
					<el-descriptions-item v-if="currentPlan.shutdownType=='2'" :label="$t('anzhouzhiding')">
						{{$t(store.state.dictJsonAll['SPECIFY_BY_WEEK'][currentPlan.weekly+''])}}
					</el-descriptions-item>
					<el-descriptions-item v-if="currentPlan.shutdownType=='1'" :label="$t('tingchankaishishijian')">
						{{dayjs.unix(currentPlan.specifyStartTime / 1000).format('YYYY-MM-DD HH:mm:ss')}}
					</el-descriptions-item>
					<el-descriptions-item v-if="currentPlan.shutdownType=='1'" :label="$t('tingchanjieshushijian')">
						{{dayjs.unix(currentPlan.specifyEndTime / 1000).format('YYYY-MM-DD HH:mm:ss')}}
					</el-descriptions-item>
					<el-descriptions-item v-if="currentPlan.shutdownType=='2'"
						:label="$t('anzhoutingchankaishishijian')">
						{{currentPlan.weekStartTime}}
					</el-descriptions-item>
					<el-descriptions-item v-if="currentPlan.shutdownType=='2'"
						:label="$t('anzhoutingchanjieshushijian')">
						{{currentPlan.weekEndTime}}
					</el-descriptions-item>
					<el-descriptions-item  :label="$t('miaoshu')">
						{{currentPlan.remark}}
					</el-descriptions-item>
				</el-descriptions>
			</div>
		</el-drawer>
	</div>

</template>
<script type="text/javascript">
	import html2canvas from 'html2canvas';
	const gantt =  Gantt.getGanttInstance();

	export default {
		name: 'web_scheduling_calendar_plan_plan_detail_index',
		components: {

		},
		data() {
			return {
				startTime: this.dayjs().startOf('month').valueOf(),
				endTime: this.dayjs().endOf('month').valueOf(),
				tasks: {
					data: [

					],
				},
				plans: [],
				currentPlan:{},
				isShowDetailDialog: false,
        setTimeRangeLoading: false,
			};
		},
		created() {
		},
		destroyed() {
			gantt.clearAll()
		},
		mounted() {
			// gantt.config.autosize = true
			// gantt.setWorkTime({hours:["00:00-23:59"]})	
			gantt.config.scale_height = 50;
			gantt.config.min_column_width = 80;
			gantt.config.time_step = 1;
			gantt.i18n.setLocale("cn");
			gantt.config.duration_unit = "minute";
			gantt.config.drag_links = false;
			gantt.config.drag_move = false;
			gantt.config.drag_progress = false;
			gantt.config.drag_resize = false;
			gantt.config.date_format = "%Y-%m-%d %H:%i";
			gantt.templates.grid_file = function(item) {
				return "";
			};
			gantt.templates.scale_row_class = function(scale) {
				return "scale_class";
			}
			gantt.templates.grid_header_class = function(columnName, column) {
				return "grid_class";
			};
			gantt.templates.grid_row_class = function(columnName, column) {
				return "grid_class";
			};
			gantt.templates.timeline_cell_class = function(task, date) {
				if (date.getDay() == 0 || date.getDay() == 6) {
					return "column_weekend";
				}
			};

			gantt.config.scales = [{
					unit: "month",
					step: 1,
					format: "%Y" + this.$t('nian') + "%M",
					css: function(date) {
						return "scale_class";
					}
				},
				{
					unit: "day",
					step: 1,
					format: "%d",
					css: function(date) {
						if (date.getDay() == 0 || date.getDay() == 6) {
							return "scale_weekend";
						} else {
							return "scale_class"
						}
					}
				},

			];
			gantt.config.columns = [{
				name: "text",
				label: "<img style='object-fit: contain;width: 136px;height: 50px' src='" + require(
					'@@/assets/img/web/production_management/gantt-task1.svg') + "' />",
				tree: true,
				width: 136
			}, ];

			gantt.attachEvent("onTaskDblClick", (id, e) => {
				//this.getGanttDetail(id)
				//return false就不会执行默认的弹框操作
				this.getGanttDetail(id.split("_")[0])
				return false;
			});
			gantt.addCalendar({
				id: "custom", // optionalworktime: {hours: ["8:00-17:00"],days: [ 1, 1, 1, 1, 1, 1 ,1]}
			});

			this.getGantt()
		},
		methods: {
			handleChange() {


				this.getGantt()

			},
			setTimeRange() {
			
				this.getGantt()
			},
			getGanttDetail(id) {
				for (var i = 0; i < this.plans.length; i++) {
					if(this.plans[i].id == id){
						this.currentPlan = this.plans[i]
						break
					}
				}
				this.isShowDetailDialog = true
			
			},
			clearAll(){
				gantt.clearAll()
			},
			getGantt() {
        this.setTimeRangeLoading = true
				gantt.clearAll()
				this.http.get('/web/production/cessation/plan/list', {
					params: {
						calendarSchemeId: this.$attrs.calendarSchemeId
					}
				}).then(res => {
					this.plans =  res.data
					let data = []
					for (var i = 0; i < res.data.length; i++) {
						let plan = res.data[i]
						
						
						
						
						
						if (plan.shutdownType == '1') {
							
							let countStartTime = plan.specifyStartTime>=this.startTime?plan.specifyStartTime:this.startTime
							let countEndTime = plan.specifyEndTime>=this.endTime?this.endTime:plan.specifyEndTime
							
							data.push({
								id: plan.id,
								text: plan.name,
								start_date:  (new Date(this.startTime)) ,
								duration: 0,
								progress: 0,
								render: 'split',
								parent: null,
								type: 'subproject',
								// color:'transparent',
								textColor: 'transparent',
							})
							
							
							data.push({
								id: plan.id + "_",
								// text: this.dayjs.unix(plan.specifyStartTime / 1000).format(
								// 	'YYYY-MM-DD HH:mm:ss')+"-"+this.dayjs.unix(plan.specifyEndTime / 1000).format(
								// 	'YYYY-MM-DD HH:mm:ss'),
								text: plan.remark? plan.remark:this.$t('chakanxiangqing'),
								start_date: this.dayjs.unix(countStartTime / 1000).format(
									'YYYY-MM-DD HH:mm:ss'),
								duration: (countEndTime - countStartTime) / 1000 / 60,
								progress: 1,
								parent: plan.id,
								color: "#FEF0F0",
								textColor: '#F56C6C',
							})
						}
						if (plan.shutdownType == '2') {
							//找出本月的周六和周日
							let start = this.dayjs(this.starTime);
							let end = this.dayjs(this.endTime);
							let weekly = parseInt(plan.weekly)
							var arr = [];
							// Get "next" monday
							let six = start.clone().day(weekly);
							if( six.isAfter(start, 'd') ){
							  arr.push(six.format('YYYY-MM-DD'));
							  six=six.add(7, 'days');
							}
							while( six.isBefore(end) ){
							  arr.push(six.format('YYYY-MM-DD'));
							  six=six.add(7, 'days');
							 }
							 
							 
							 for (var j = 0; j < arr.length; j++) {
								 
								 let weekStartTime = this.dayjs(arr[j]+" "+plan.weekStartTime).valueOf()
								 let weekEndTime = this.dayjs(arr[j]+" "+plan.weekEndTime).valueOf()
								 
								 let countStartTime = weekStartTime>=this.startTime?weekStartTime:this.startTime
								 let countEndTime = weekEndTime>=this.endTime?this.endTime:weekEndTime
								 
							 	if(j==0){
									data.push({
										id: plan.id,
										text: plan.name,
										start_date: this.dayjs.unix(countStartTime / 1000).format(
									'YYYY-MM-DD HH:mm:ss'),
										duration: 0,
										progress: 0,
										render: 'split',
										parent: null,
										type: 'subproject',
										// color:'transparent',
										textColor: 'transparent',
									})
								}
								data.push({
									id: plan.id + "_"+j,
									text: plan.remark?plan.remark:"",
									start_date: this.dayjs.unix(countStartTime / 1000).format(
									'YYYY-MM-DD HH:mm:ss'),
									duration:(countEndTime - countStartTime) / 1000 / 60,
									progress: 1,
									parent: plan.id,
									color: "#FEF0F0",
									textColor: '#F56C6C',
									
								})
							 }
							 
							 
							
						
						}



					}
					console.log(data)
					this.tasks.data = data
					gantt.init(this.$refs.planGanttContainer);
					gantt.parse(this.tasks);


					gantt.config.start_date = (new Date(this.startTime))
					gantt.config.end_date = (new Date(this.endTime))
          this.setTimeRangeLoading = false

					// if (this.days == null) {
					// 	gantt.config.start_date = null;
					// 	gantt.config.end_date = null;
					// } else {
					// 	let startTime = new Date().getTime()
					// 	for (var i = 0; i < this.eqs.length; i++) {
					// 		let eq = this.eqs[i]
					// 		for (var j = 0; j < eq.taskList.length; j++) {
					// 			let wo = eq.taskList[j]
					// 			if (wo.startTime < startTime) {
					// 				startTime = wo.startTime
					// 			}
					// 		}
					// 	}

					// 	gantt.config.start_date = new Date(startTime);
					// 	gantt.config.end_date = new Date(new Date().getTime() + this.days * 24 * 60 * 60 * 1000);

					// }


					setTimeout(() => {
						gantt.setSizes()
            this.setTimeRangeLoading = false
					}, 0)



				}).catch(error => {})
			},

		},
	};
</script>